var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"vi-message-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],class:[
    'vi-message',
    _vm.type && !_vm.iconClass ? ("vi-message--" + _vm.type) : '',
    _vm.center ? 'is-center' : '',
    _vm.showClose ? 'is-closable' : '',
    _vm.customClass],attrs:{"role":"alert"},on:{"mouseenter":_vm.clearTimer,"mouseleave":_vm.startTimer}},[_vm._t("default",[_c('p',{staticClass:"vi-message__content"},[(_vm.iconClass)?_c('i',{class:_vm.iconClass}):_c('i',{class:_vm.typeClass}),_vm._v(_vm._s(_vm.message))])]),_vm._v(" "),(_vm.showClose)?_c('i',{staticClass:"vi-message__closeBtn vi-icon-close",on:{"click":_vm.close}}):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e47f43c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/message/src/main.vue
// module id = null
// module chunks = 